import React from 'react';
import { NButton, NInput } from '@innersource-nn/novoui-react';
import { DatasetCreateFormData } from 'types/Forms';
import NTextAreaQuill from 'components/Inputs/TextAreaQuill/NTextAreaQuill';
interface StepProps {
    handleNext(index: number): void;
    formData: DatasetCreateFormData;
    setFormData: React.Dispatch<React.SetStateAction<DatasetCreateFormData>>;
}
export default function SecondStep({
    handleNext,
    formData,
    setFormData,
}: StepProps) {
    return (
        <div>
            <div className="flex flex-col gap-16 mr-24">
                <NInput
                    label="Dataset name *"
                    size="medium"
                    variant="outline"
                    placeholder="Maximum 52 characters..."
                    modelValue={formData.label}
                    invalid={formData.label.length > 52}
                    assistiveText={
                        formData.label.length > 52
                            ? 'Maximum 52 characters are allowed'
                            : ''
                    }
                    onChange={(e) =>
                        setFormData({
                            ...formData,
                            label: e.target.value,
                        })
                    }
                />
                <NTextAreaQuill
                    label="Dataset description *"
                    variant="outline"
                    placeholder="Please insert a short description which describes what this dataset contains and the purpose of the dataset..."
                    modelValue={formData.description}
                    onChange={(value) =>
                        setFormData({
                            ...formData,
                            description: value,
                        })
                    }
                />
            </div>
            <NButton
                variant="fill"
                square
                className="bg-sea-blue-600 mt-16"
                onClick={() => handleNext(1)}
                disabled={
                    formData.description === '' ||
                    formData.label === '' ||
                    formData.label.length > 52
                }
            >
                Next step
            </NButton>
        </div>
    );
}
